<template>
  <div
    ref="draggableContainer"
    id="draggable-container"
    class="box-sign"
  >
    <!--<div class="box-sign" @mousedown="dragMouseDown">-->
    <div v-on:click="closeSign" class="button-close">x</div>
    <div v-on="handlers">
      <div class="c-timbre">
      </div>
      <div class="c-datos" v-if="processType.toLowerCase() === 'numerar'">
        <div class="dato-numeration">
          NNN
        </div>
      </div>
      <div class="c-datos-process" v-if="processType.toLowerCase() === 'tramitar'">
        <div>
          <div class="dato-process">
            T
          </div>
        </div>
      </div>
      <div class="c-date-process" v-if="processType.toLowerCase() === 'fechar'">
        <div class="dato-date-process">
          2022-04-01
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { rolTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  props: {
    position: {
      type: Object,
      required: true
    },
    processType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stepTypes: rolTypesCode,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      handlers: {
        mousedown: this.dragMouseDown,
        touchend: this.closeDragElement,
        touchstart: this.touchMouseDown
      }
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    closeSign() {
      this.$emit('close');
    },
    setPosition() {
      this.$refs.draggableContainer.style.left = `${this.position.x}px`;
      this.$refs.draggableContainer.style.top = `${this.position.y}px`;
    },
    getPosition() {
      const position = {
        absoluteX: this.$refs.draggableContainer.offsetLeft,
        absoluteY: this.$refs.draggableContainer.offsetTop,
        height: this.$refs.draggableContainer.offsetHeight,
        width: this.$refs.draggableContainer.offsetWidth
      };
      return position;
    },
    touchMouseDown(event) {
      event.preventDefault();
      event.stopPropagation();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.touchmove = this.elementDrag;
      document.addEventListener('touchstart', this.dragMouseDown, false);
      document.addEventListener('touchmove', this.elementDrag, false);
    },
    dragMouseDown(event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
      document.touchmove = this.elementDrag;
    },
    elementDrag(event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      if (this.$refs.draggableContainer) {
        this.$refs.draggableContainer.style.top = `${this.$refs.draggableContainer.offsetTop - this.positions.movementY }px`;
        this.$refs.draggableContainer.style.left = `${this.$refs.draggableContainer.offsetLeft - this.positions.movementX }px`;
      }
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
      document.touchend = null;
      document.touchcancel = null;
    }
  },
  mounted() {
    this.setPosition();
  }
};
</script>

<style scoped>
#draggable-container {
  position: absolute;
  z-index: 9;
}
.box-sign {
  width: 150px;
  height: 50px;
  border: dotted 1px green;
  cursor: pointer;
  position: absolute;
  z-index: 1;
}
.box-sign .c-timbre {
  position: relative;
  height: 50px;
  width: 50px;
  border-radius: 50px;
  background-color: rgb(0, 255, 0);
  opacity: 0.6;
  margin: 0 auto !important;
}
.box-sign .dato-numeration {
  font-size: 26px;
  font-family: monospace;
  line-height: 40px;
}
.box-sign .dato-process {
  font-size: 26px;
  font-family: monospace;
  line-height: 40px;
}
.box-sign .dato-date-process {
  font-size: 16px;
  font-family: monospace;
  line-height: 20px;
}
.box-sign .c-date-process {
  line-height: 12px;
  position: absolute;
  top: 1px;
}
.box-sign .c-datos {
  line-height: 12px;
  position: absolute;
  top: 1px;
  right: 50px;
}
.box-sign .c-datos-process {
  line-height: 12px;
  position: absolute;
  top: 1px;
  right: 66px;
}
.button-close {
  position: absolute;
  top: -5px;
  right: -2px;
  background-color: #ee5f5f;
  color: white;
  border-radius: 8px;
  padding: 0 4px;
  font-size: 10px;
  z-index: 10;
}
</style>
